@switch (featureData.mediaSourceType) {
  @case (MediaSourceType.Video) {
    <video height="360" autoplay loop muted>
      <source [src]="featureData.mediaSource" type="video/mp4" />
      @if (featureData?.fallbackImgSource) {
        <img
          alt="{{ featureData?.title }}"
          src="{{ featureData.fallbackImgSource }}"
          [style.minHeight]="'360px'"
        />
      }
    </video>
  }

  @case (MediaSourceType.YoutubeVideo) {
    <iframe
      [src]="safeUrl"
      height="360"
      type="text/html"
      width="100%"
      frameborder="0"
      allowFullScreen
      mozallowfullscreen
      webkitAllowFullScreen
    >
    </iframe>
  }

  @case (MediaSourceType.Image) {
    <img
      alt="{{ featureData?.title }}"
      src="{{ $safeNavigationMigration(featureData?.mediaSource)! | rtThemeImg }}"
      [style.minHeight]="'360px'"
    />
  }
}

<div layout-full-width layout-vertical layout-centered-y padding text-center>
  <rt-heading variant="heading large-xx">{{ featureData?.title }}</rt-heading>
  <div
    [innerHTML]="$safeNavigationMigration(featureData?.description)"
    margin-top-small-xx
    class="feature-desc"
  ></div>
  @if (canUpgrade) {
    <div>
      @if (customUpgradeButton) {
        <ng-container *ngTemplateOutlet="customUpgradeButton" />
      } @else {
        @if (canUpgrade) {
          <rt-feature-button
            (openPlanPicker)="openPlanPicker.emit()"
            [plan]="availableFromPlan()"
            [availableInNewPlans]="availableInNewPlans()"
            margin-top-small
            >{{ 'app.pricing.feature_guard.upgrade_plan' | translate }}
          </rt-feature-button>
        }
      }
    </div>
  }

  @if (featureData.helpArticleKey) {
    <a [rtHelpArticle]="featureData.helpArticleKey" margin-top-small-x text-underline class="link">
      {{ featureData.learnMoreTranslationKey || 'app.common.learn_more' | translate }}
    </a>
  } @else {
    <a
      [href]="featureData.helpUrl || featureData.learnMoreUrlByLang![helpArticleLang]"
      target="_blank"
      margin-top-small-x
      text-underline
      class="link"
      >{{ featureData.learnMoreTranslationKey || 'app.common.learn_more' | translate }}
    </a>
  }
</div>
